<au-native-input
	[placeholder]="placeholderText ?? ('placeholder_operations_search_bar' | translate)"
	(inputChanged)="searchHandler($event)"
	(controlReady)="controlReadyHandler($event)"
></au-native-input>
